// @flow
import type { AudienceData, ValidatedAdvertisement } from '../../types'
import { Audience } from '../../constants'
import type { PreviewData } from '../NamedPreview'
import _ from 'lodash'

export default function prepareDataForPreview(props: {|
  audienceData: AudienceData,
  advertisement: ValidatedAdvertisement
|}): PreviewData {
  const advertisement: Object = props.advertisement
  const {
    url,
    title,
    multiImage,
    logoImage,
    logoImageCrop,
    video,
    columnDescription,
    multiDescription,
    productDescription
  } = advertisement
  const { vkPublic, fbPublic, vkPlacement } = props.audienceData
  const description = columnDescription || multiDescription || productDescription

  return {
    url: extractDomainFromUrl(url),
    title: title,
    vkTitle: advertisement.vkTitle || title,
    fbTitle: advertisement.fbTitle || title,
    description: description,
    vkExtendedDescription:
      advertisement.vkMultiDescription || advertisement.vkWithoutButtonDescription || description,
    fbExtendedDescription: advertisement.fbMultiDescription || description,
    image: multiImage,
    vkImageCrop:
      advertisement.vkColumnCrop ||
      advertisement.vkMultiCrop ||
      advertisement.vkArticleCrop ||
      advertisement.vkSiteCrop,
    tmImageCrop: advertisement.tmColumnCrop || advertisement.tmMultiCrop,
    fbImageCrop: advertisement.fbImageCrop,
    glImageCrop: advertisement.glImageCrop,
    linkTitle: advertisement.vkLinkTitle,
    logoImage,
    logoImageCrop,
    vkPublic,
    fbPublic,
    video,
    vkHasButton: !_.includes(
      [
        Audience.vk_placements.promopost_without_button,
        Audience.vk_placements.promopost_with_big_image
      ],
      vkPlacement
    ),
    tmSmallImage: advertisement.tmSmallImage,
    tmSmallImageCrop: advertisement.tmSmallImageCrop,
    tmLinkButton: advertisement.tmLinkButton,
    instagramImage: advertisement.fbInstagramImage,
    instagramImageCrop: advertisement.fbInstagramImageCrop,
    fbLinkButton: advertisement.fbLinkButton,
    vkLinkButton: advertisement.vkLinkButton,
    fbThumbnailImage: advertisement.fbThumbnailImage,
    fbThumbnailImageCrop: advertisement.fbThumbnailImageCrop,
    vkBigImage: advertisement.vkBigImage
  }
}

export function extractDomainFromUrl(url: string) {
  return url ? url.replace(/^(https?:\/\/)?(www\.)?([a-zа-я\-.\d]*)?\/?.*?$/gi, '$3') : ''
}
